import { jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { Nowrap } from "../Nowrap.js";
import { spreadSx } from "../../utils/spreadSx.js";
const ListItemText = ({ children, lines = 100, variant = "text", size = "md", sx }) => /* @__PURE__ */ jsx(
  Typography,
  {
    sx: [
      sizeStyles.txtVars[variant][size],
      styles.container,
      ...spreadSx(sx)
    ],
    children: /* @__PURE__ */ jsx(Nowrap, { lines, children })
  }
), styles = {
  container: {
    minWidth: 100,
    color: (t) => t.palette.ddrow.content.default
  }
}, sizeStyles = {
  txtVars: {
    subtitle: {
      md: {
        fontSize: "12px",
        lineHeight: "18px",
        fontWeight: "500"
      },
      lg: {
        fontSize: "12px",
        lineHeight: "18px",
        fontWeight: "500"
      }
    },
    text: {
      md: {
        fontSize: "14px",
        lineHeight: "18px",
        fontWeight: "500"
      },
      lg: {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "500"
      }
    },
    primary: {
      md: {
        fontSize: "14px",
        lineHeight: "18px",
        fontWeight: "700"
      },
      lg: {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "700"
      }
    }
  }
};
export {
  ListItemText
};
//# sourceMappingURL=ListItemText.js.map
